import React from "react";
import { GetImages } from "../../utils/GetImages";

interface Props {
  docImage?: any;
  docNumber?: number;
  avatar: boolean;
  Size: String;
  isProperty?: boolean;
}

export const AvatarWithLoading: React.FC<Props> = React.memo(
  ({ docImage = null, avatar = false, Size, isProperty }) => {

    return (
      <>
        <img
          className={`${Size}`}
          style={{ width: 60, height: 60, borderRadius: 4 }}
          src={
            avatar && docImage
              ? `data:image/*;base64,${docImage}`
              : isProperty ? GetImages.PropertyPlaceholder
                : GetImages.UnitPlaceholder
          }
        />
      </>
    );
  }
);
